import React from 'react';
//Components 
import { Tab, Nav } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
//Internal components
import Navbar from '../NavBar/Navbar';
import BankStatements from './BankStatements';
import TransactionConciliation from './TransactionReconciliation';
import StatesBankConsolidation from "./StatesBankConsolidation";
import StatesBankBatchConsolidation from './StatesBankBatchConsolidation';
import ConsilitionHistory from './ConsilitionHistory';
import ImgConciliation from './ImageConciliations';
import Footer from '../Footer/Footer';
import BankTransactions from './BankTransactions';
const BankConsiliation = () => {
    return (
        <>
            <Navbar titlePage="Informes" route="bank/new_consiliation" />
            <main className='bg-light-subtle  pt-4 pb-5'>
                <div className="container">

                    {/** Header */}


                    <section className='banner-sp bg-light-subtle d-lg-flex justify-content-lg-between 
                  align-items-center rounded-4 mb-3 flex-column flex-lg-row justify-content-center py-2 py-lg-0'>


                        <div className='d-lg-flex flex-lg-stack flex-wrap gap-4 w-100 flex-nowrap d-flex justify-content-center align-items-center 
                  justify-content-lg-start'>
                            <div className='page-title d-flex flex-column gap-0 me-3'>
                                <h2 className='banner-reports-title mb-0 pb-0'>
                                    Conciliacion Bancaria
                                </h2>
                                <p className='m-0 p-0 banner-reports-description'>Agrupa varios créditos, proceso contable que compara los registros contables de una empresa con los movimientos bancarios.</p>
                            </div>
                        </div>

                    </section>
                    {/** End Header  */}
                    {/**Tabs */}
                    <Tab.Container defaultActiveKey={"BankStatements"}>
                        <Row>
                            <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                                <Nav variant="pills" className="d-flex horizontal-scroll bg-white rounded-3 gap-3 ">

                                    <li className="nav-sp-item bg-light rounded-3 border">
                                        <Nav.Link eventKey="BankStatements" >
                                            Movimientos bancarios</Nav.Link>
                                    </li>
                                </Nav>
                            </div>

                            {/** Content of the tabs */}
                            <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                                <Tab.Content>
                                    <Tab.Pane eventKey="BankStatements">
                                        <BankStatements />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="loteConsolidation">
                                        <div className=' m-0'>
                                            <TransactionConciliation />
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="StatesBankBatchConsolidation">
                                        <div className=' m-0'>
                                            <StatesBankBatchConsolidation />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="StatesBankConsolidation">
                                        <div className=' m-0'>
                                            <StatesBankConsolidation />
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="reportConciliation">
                                        <div className=' m-0'>
                                            <ConsilitionHistory />
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="imgConciliation">
                                        <div className=' m-0'>
                                            <ImgConciliation />
                                        </div>
                                    </Tab.Pane>

                                </Tab.Content>
                            </div>
                        </Row>
                    </Tab.Container>
                </div >
            </main >
            <Footer />
        </>
    );
}

export default BankConsiliation;
